import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Compass } from 'lucide-react';

import { Button } from '@/components/ui/Button';
import { EmptyState } from '@/components/ui/EmptyState';
import { DEFAULT_ROUTE } from '@/config/routes';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<Compass size={28} />}
      title={t('notFound.description')}
      className="min-h-[360px] border-none bg-transparent"
      action={
        <Button onClick={() => navigate(DEFAULT_ROUTE)}>{t('notFound.action')}</Button>
      }
    />
  );
}
